import { inject, Injectable } from '@angular/core';
import { DpCharPatternValidator, DpFieldText, DpFormRow, DpModalForm, DpModalFormService, DpModalFormSize, DpValidationRegex } from '@docpath/webcomponents';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CloudService } from 'src/app/shared/services/cloud.service';

import { Alias } from '../models/alias';
import { AliasService } from './alias.service';
import { AliasHttpService } from './alias-http.service';

@Injectable({
    providedIn: 'root'
})
export class AliasFormService {
    readonly i18nPrefix = 'alias-config.alias-row.form';


    private readonly modalFormService = inject(DpModalFormService);
    private readonly aliasHttpService = inject(AliasHttpService);
    private readonly aliasService = inject(AliasService);
    private readonly cloudService = inject(CloudService);

    initAliasForm(): DpModalForm {
        return new DpModalForm({
            header: `${this.i18nPrefix}.header.new-alias`,
            rows: [
                new DpFormRow([
                    new DpFieldText({ name: 'alert_alias', required: true, column: 10, maxLength: 255 })
                ]),
                new DpFormRow([
                    new DpFieldText({
                        name: 'email', column: 10, maxLength: 255,
                        validators: [
                            new DpCharPatternValidator({ pattern: DpValidationRegex.char.noSpaces })
                        ]
                    })
                ]),
                new DpFormRow([
                    new DpFieldText({
                        name: 'phone_number', column: 10, hidden: this.isPhoneNumberHidden(), maxLength:100,
                        validators: [
                            new DpCharPatternValidator({ pattern: DpValidationRegex.char.phoneNumber })
                        ]
                    })
                ])
            ],
            size: DpModalFormSize.Xl,
            i18nPrefix: this.i18nPrefix
        });
    }

    private isPhoneNumberHidden(): boolean {
        let hidden: boolean = false;

        if (this.cloudService.isModeCloud()) {
            hidden = true;
        }

        return hidden;
    }

    openCreateAliasForm(): void {
        const form = this.initAliasForm();
        form.header = `${this.i18nPrefix}.header.new-alias`;

        form.submit = (value, activeModal) => {
            this.postAlias(
                value as Alias,
                activeModal as unknown as NgbModalRef
            );
        };

        this.modalFormService.open(form);
    }


    private putAlias(alias: Alias, activeModal: NgbModalRef): void {
        this.aliasHttpService.editAlias(alias, () => {
            activeModal.close();
            this.aliasService.notifyAliasChange();
        });
    }

    openEditAliasForm(alias: Alias): void {
        const form = this.initAliasForm();
        form.header = `${this.i18nPrefix}.header.edit-alias`;

        const modalReference = this.modalFormService.open(form);

        form.submit = (value, activeModal) => {
            const role = { id: alias.id, ...value };
            this.putAlias(
                role,
                activeModal as unknown as NgbModalRef
            );
        };

        modalReference.shown.subscribe(() => {
            form.setValue(alias);
        });
    }

    private postAlias(alias: Alias, activeModal: NgbModalRef): void {
        this.aliasHttpService.createAlias(alias, () => {
            activeModal.close();
            this.aliasService.notifyAliasChange();
        });
    }

}